import { PdfItem } from '../../pages/pdf/types';

interface Props {
  data: PdfItem['data'];
}

export const PdfTip = ({ data }: Props) => {
  const { content } = data;
  const { title } = data;

  return (
    <div className="px-2">
      <h4 className="bg-dark-blue p-2 text-white ">{title}</h4>
      <p className="pt-2">{content}</p>
    </div>
  );
};
